import React, { useState } from "react";
import { Toast } from "../UI/toast/Toast";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { fetchProperties } from "../../helpers/api/condominium";
import PageHeader from "../common/PageHeader";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams } from "react-router";
import {
  createAliquot,
  fetchCreateReserveFund,
} from "../../helpers/api/finance";
import { useSelector } from "react-redux";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import CreateAliquotForm from "../finance/CreateAliquotForm";
import { PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import CreateReserveFundForm from "./CreateReserveFundForm";
import CreatePaymentFundForm from "./CreatePaymentFundForm";

const CreatePaymentFund = ({ setRedirectUrl, setRedirect }) => {
  const { id } = useParams();

  const [params] = useState({
    condominiumId: id,
  });

  const { isLoading } = params;

  const { selectedCondominium } = useSelector((state) => state.condominium);
  /*   const {
    data,
    isLoading,
    meta,
    handler: { nextPage, previousPage, perPage, goToPage },
  } = useSWRFetchPagination(fetchProperties, params); */

  const create = async (values) => {
    try {
      const { code } = await fetchCreateReserveFund(selectedCondominium, values);

      if (code === SUCCESS_RESPONSE.OK) {
        setRedirectUrl(`/dashboard/finance/${id}/reserve-funds`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Fondo de reserva registrado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  return (
    <>
      <PageHeader
        title="Emitir cobro para fondo"
        titleTag="h2"
        description="Registra un fondo de reserva a tu condominio."
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <PreloadState loading={isLoading}>
        <CreatePaymentFundForm handleSubmitData={create} />
      </PreloadState>
    </>
  );
};

export default withRedirect(CreatePaymentFund);
